import { FC } from "react";
import { Button, HStack, Icon, Text } from "@chakra-ui/react";

import { LockIcon } from "../../../../icons";
import { useAppModal } from "../../../Modals";
import { MainPageSbpTransferModal } from "../Modal";

export const MainPageSbpTransferCooling: FC = () => {
  const { showModal } = useAppModal();

  const onClick = () => {
    const text = "Договор находится в периоде охлаждения. Дождитесь его окончания — после этого перевод себе на счёт станет доступен.";

    showModal({
      content: onClose => (
        <MainPageSbpTransferModal
          text={text}
          onClose={onClose}
        />
      ),
    });
  };

  return (
    <HStack mb="11px" justifyContent="space-between">
      <Text fontSize="14px">Перевод временно недоступен</Text>

      <Button minW="20px" h="20px" p="0" colorScheme="transparent" onClick={onClick}>
        <Icon as={LockIcon} boxSize="20px" />
      </Button>
    </HStack>
  );
};
